import UserList from '@/pages/components/manage/sys/user/UserList';

export default {
    list: UserList,
    recordRepresentation: 'username',
};
